<template>
    <div class="sub-item" v-if="device">
        <div class="btn">
            <material-switch v-model="power" @change="togglePower"
                             :loading="loading" :disabled="device.connection !== connectionState.online"
                             true-value="on" false-value="off"
            ></material-switch>
        </div>
        <div class="content">
            <div class="title" @click="openDevPage()"
                 :class="{'active': $route.params.devId == device.id}">{{device.title || device.serial}}</div>
            <div class="sub-title" v-show="isOnline">В помещении:<br> t {{device.cur_temp}}°C</div>
        </div>
        <div class="status">
            <div class="signal" :title="device.connection" :class="{'online': isOnline}"></div>
            <div class="temp" v-show="isOnline">{{device.set_temp}}℃</div>
        </div>
    </div>
</template>

<script>
    import { cmdVals, devApi } from '../../api/device'
    import { connectionState } from '../../other/consts'
    import { mapActions } from 'vuex'
    import cfg  from '../../config'
    import materialSwitch  from '../elements/material-switch'

    export default {
        components:{
            materialSwitch
        },
        props: ['devId'],
        data() {
            return {
                connectionState,
                loading: false,
                power: 'off',
            }
        },
        methods: {
            togglePower() {

                // devApi.mqttCtrl.ctrl(this.$mqtt, this.device, cmdVals.power, this.power);
                devApi.http.ctrl(this.devId, 'isOn', this.power === 'on');
                return;

                this.loading = true;

                let waitingTimer = setTimeout(() => {
                    this.loading = false;
                    this.showCtrlFailAlert();
                    devApi.http.addFailStat(this.devId)
                }, cfg.mqtt.cmdTimeout)

                this.$mqtt.addListener( `dev_${this.device.serial}_power_single_l`,
                    `^/devices/conditioner/controls/${this.device.serial}/out/power$`,
                    (matches, msg) => {
                        this.loading = false
                        clearTimeout(waitingTimer)
                    }, {
                        once: true,
                    })
            },
            openDevPage(){
                // this.$router.push({ name: 'device', params: { devId: this.devId }})
                this.$router.push({ name: 'device', params: { buildingId: this.$route.params.buildingId, devId: this.devId }})
                this.hideLeftMenu();
            },
            ...mapActions([
                'hideCtrlFailAlert',
                'hideLeftMenu',
            ]),
        },
        created(){
            this.power = this.device ? this.device.power : 'off';
        },
        watch:{
            'device.power'(newVal, oldVal){
                this.power = newVal;
            }
        },
        computed:{
            device(){
                return this.$store.state.devs.all[this.devId];
            },
            isOnline(){
                return this.device.connection === connectionState.online
            }
        }
    }
</script>
